import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext, Generic4xx } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path={routes.storeLocator.path}
          element={
            channel === 'mobile'
              ? <routes.storeLocatorMobile.component />
              : <routes.storeLocator.component />
          }
        />
        <Route path={routes.storeDirectory.path} element={<routes.storeDirectory.component />} />
        <Route path={routes.stateDirectory.path} element={<routes.stateDirectory.component />} />
        <Route path={routes.localCity.path} element={<routes.localCity.component />} />
        <Route path={routes.storeDetails.path} element={<routes.storeDetails.component />} />
        <Route path={routes.storeReviews.path} element={<routes.storeReviews.component />} />
        <Route path={routes.homeServices.path} element={<routes.homeServices.component />} />
        <Route path={routes.rentalServices.path} element={<routes.rentalServices.component />} />
        <Route path={routes.gardenCenter.path} element={<routes.gardenCenter.component />} />
        <Route path={routes.proDesk.path} element={<routes.proDesk.component />} />
        <Route path="/error" element={<Error />} />
        <Route path="/*" element={<Generic4xx />} />
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {
  stores: []
};